"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("styled-components").css`
    .details-pane-secondary--options {
        display: grid;
        grid-template-columns: 1fr 2fr;
        gap: 20px 0;
    }
    .details-pane-secondary--options > div > div:first-child {
        font-weight: 600;
    }
    .details-pane-secondary--options > div > div:not(:first-child) {
        font-size: 18px;
        color: #777b7e;
    }
`;exports.default=e,exports.stylesModelDetails=e;
//# sourceMappingURL=styles.js.map
